import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Promotions from '../../../Promotions/index';

export default () => (
  <Switch>
    <Route exact path="/promotions" component={Promotions} />
  </Switch>
);
